export type SequenceResult<T, R> = { item: T; status: 'fulfilled'; value: R } | { item: T; status: 'rejected'; reason: unknown };

/** Like Promise.allSettled, but one item at a time — for writes that must not race each other. */
export const settleInSequence = async <T, R>(items: readonly T[], run: (item: T) => Promise<R>, onSettled?: (settledCount: number) => void): Promise<SequenceResult<T, R>[]> => {
  const results: SequenceResult<T, R>[] = [];
  for (const item of items) {
    try {
      results.push({ item, status: 'fulfilled', value: await run(item) });
    } catch (reason) {
      results.push({ item, status: 'rejected', reason });
    }
    onSettled?.(results.length);
  }
  return results;
};
